import styled from "styled-components"

import { color } from "../../../atoms/colors"

export const Box = styled.div`
  display: block;
  width: 100%;
  background-color: ${color.common.white};
  padding: 40px 0;
  @media (min-width: 769px) {
    padding: 56px 0;
  }
  @media (min-width: 993px) {
    padding: 96px 0;
  }
  h2.container-title {
    font-style: normal;
    font-weight: 900;
    text-align: center;
    letter-spacing: -0.02em;
    color: ${color.oxfordBlue[900]};
    width: 100%;
    max-width: 506px;
    font-size: 24px;
    line-height: 32px;
    @media (min-width: 577px) {
      font-size: 30px;
      line-height: 38px;
    }
    @media (min-width: 769px) {
      font-size: 36px;
      line-height: 44px;
      max-width: 760px;
    }
  }
`

export const TestimonialContainer = styled.div`
  margin: 0 auto;
  padding: 30px;
  max-width: 566px;
  @media (min-width: 769px) {
    max-width: 830px;
  }
  @media (min-width: 993px) {
    max-width: 1230px;
  }
  .swiper {
    margin: 48px 0px;
    @media (min-width: 577px) {
      margin: 64px 0px;
    }
    @media (min-width: 993px) {
      margin: 96px 0px;
    }
    .swiper-slide {
      padding: 0px 12px;
    }
  }
`
export const VideoSliderHeader = styled.div`
  display: flex;
  max-width: 1170px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 991px) {
    margin-bottom: 48px;
  }
  .eyebrow {
    margin: 16px 0;
    text-transform: uppercase;
    color: ${color.primary[700]};
    font-weight: 900;
  }
  .container-header {
    font-size: 48px;
    font-weight: 900;
    line-height: 60px;
    font-style: normal;
    text-align: center;
    letter-spacing: -0.02em;
  }
  .text-area {
    max-width: 66%;
    margin: 0px;
  }
`
